import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { buildCheckoutUrl } from '../utils/checkout';
export function LastChance() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-126" data-mp="1sjm30o04s98z">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-127" data-mp="1nmca2ydj9fge"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-128" data-mp="1jkqz5ikk7b8u">
        <div className="max-w-3xl mx-auto text-center" data-id="element-129" data-mp="1jmbuhaep6y7r">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-130" data-mp="1eshbk96x2n9q">
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-8" data-id="element-131" data-mp="zvzzffqwl4m4">
              LAST CHANCE
            </h2>

            <div className="prose prose-lg prose-invert mx-auto text-gray-300 mb-12" data-id="element-132" data-mp="vv6d2qt3zxvc">
              <p className="text-xl font-medium text-white" data-id="element-133" data-mp="2ind9837vca7t">
                Your players deserve the best version of you.
              </p>
              <p data-id="element-134" data-mp="2ngojyffsxb50">Not a coach improvising every training session.</p>
              <p data-id="element-135" data-mp="28rjz0qhmgst7">
                Stop spending evenings searching for drills.
                <br data-id="element-136" data-mp="2dq3lcs04o6m3" />
                Stop building sessions from scratch.
              </p>
              <p className="text-xl text-gold-400 font-medium mt-6" data-id="element-137" data-mp="31ed41l21oe90">
                Take control of your season with a complete coaching system
                designed to save time and develop better players.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border border-navy-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-138" data-mp="2wfjnfjrgo74m">
            <h3 className="font-anton text-3xl md:text-4xl text-white uppercase tracking-wide mb-2" data-id="element-139" data-mp="3np4nkvgqbd9i">
              FOOTBALL READY: SYSTEM 365
            </h3>
            <p className="font-oswald text-xl text-gold-500 uppercase tracking-widest mb-8" data-id="element-140" data-mp="3dw73ikw39g8s">
              6 Complete Volumes + 5 Premium Bonuses
            </p>

            <div className="mb-8" data-id="element-141" data-mp="34wk8cgtyd6o6">
              <div className="text-gray-400 font-oswald text-lg line-through mb-1" data-id="element-142" data-mp="34xllcquj438j">
                Regular Price: USD 97
              </div>
              <div className="text-gold-500 font-oswald text-xl uppercase tracking-widest mb-1" data-id="element-143" data-mp="2zzk2o710m5xl">
                Today Only:
              </div>
              <div className="font-anton text-6xl text-white tracking-wider mb-3" data-id="element-144" data-mp="2q032g54j8k90">
                USD 19
              </div>
              <p className="inline-flex items-center gap-2 text-gold-400 text-sm font-medium" data-id="element-145" data-mp="t6hpga37lyh5">
                <Globe className="w-4 h-4" data-id="element-146" data-mp="o97zmtbwrkss" />
                Pay securely in your local currency.
              </p>
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-147" data-mp="wn4d8k5n18hg">
              <Button size="xl" fullWidth onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 19,
                currency: 'USD'
              });
              window.location.href = buildCheckoutUrl();
            }} data-id="element-148" data-mp="10p7op8sb4d2q">
                YES, I WANT FOOTBALL READY NOW
              </Button>

              <div className="text-green-400 font-medium" data-id="element-149" data-mp="hthnvow41mqf">
                Instant Access — Delivered By Email
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-150" data-mp="rqdpdanld8lh">
                <div className="flex items-center gap-1" data-id="element-151" data-mp="rnhpvhw3ibux">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-152" data-mp="2350wzlcsqyyr" data-mpi={i} />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-153" data-mp="3c27v550n7o4d">
                    4.9/5 — Verified Reviews
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-154" data-mp="3l3p668z70zm7">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-155" data-mp="3g39t7iitpu4r" />
                  <span data-id="element-156" data-mp="3v0ttwd8ot354">7-Day Money Back Guarantee — Zero Risk</span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-157" data-mp="3uyh5bh8fbuj3">
                  <Globe className="w-4 h-4 text-gold-500" data-id="element-158" data-mp="3pzweu9iz4p7u" />
                  <span data-id="element-159" data-mp="7mg5e4aidlnt">Pay In Your Local Currency</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}